module.exports = ($scope, $state, $stateParams, $uibModal, factivaToken) ->

  $scope.addPlugin = () ->
    pluginModal = $uibModal.open
      template: require('./plugins-modal.html')
      controller: 'PluginsModalController'
      size: 'md'
    pluginModal.result.then () ->

  $scope.userHasFactiva = () ->
    factivaToken.client_has_token

  $scope.addFactivaPlugin = () ->
    pluginModal = $uibModal.open
      template: require('./FactivaLoginModal/factiva-login-modal.html')
      controller: 'FactivaLoginModalController'
    pluginModal.result.then () ->
      $state.transitionTo $state.current.name, $stateParams, reload: $state.current.name
      return
